import { InstructionType } from 'app/src/engine/Instruction';
import { ProgramStoreContextProvider } from 'app/src/game/ProgramStoreContext';
import * as React from 'react';

type Props = {
	children: React.ReactNode;
};

export default function ProgramStoreController({ children }: Props): React.ReactElement | null {
	const [program, setProgram] = React.useState<InstructionType[]>([]);

	const addInstruction = (type: InstructionType, index: number = program.length): void => {
		if (index < 0 || index > program.length) {
			return;
		}

		const newProgram = [...program];
		newProgram.splice(index, 0, type);
		setProgram(newProgram);
	};

	const removeInstruction = (index: number): void => {
		if (index < 0 || index >= program.length) {
			return;
		}

		const newProgram = [...program];
		newProgram.splice(index, 1);
		setProgram(newProgram);
	};

	const reorderInstruction = (from: number, to: number): void => {
		if (from < 0 || from >= program.length || to < 0 || to > program.length) {
			return;
		}

		const moveType = program[from];

		const newProgram = [...program];
		newProgram.splice(from, 1);
		newProgram.splice(to, 0, moveType);

		setProgram(newProgram);
	};

	const clearInstructions = (): void => {
		setProgram([]);
	};

	return (
		<ProgramStoreContextProvider
			value={{
				program,
				setProgram,
				addInstruction,
				removeInstruction,
				reorderInstruction,
				clearInstructions,
			}}
		>
			{children}
		</ProgramStoreContextProvider>
	);
}
